<template>
    <div>
        <FatorRisco
            :form="form"
            :model="model"
        />

        <Alergia
            :data="{ form, model }"
            hide-info
        />

        <MedicamentoUsoContinuo
            :data="{ form, model }"
            hide-info
        />
    </div>
</template>

<script>
import FatorRisco from './components/fator-risco/Index'
import Alergia from '@/components/cadastro/cidadao/components/alergia/Index'
import MedicamentoUsoContinuo from '@/components/cadastro/cidadao/components/medicamento-uso-continuo/Index'

export default {
    components: { FatorRisco, Alergia, MedicamentoUsoContinuo },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
}
</script>